import { useMutation } from "react-query";
import remarkService from "../services/remarkService";

const useInsertRemarkData = (onData) => {
  return useMutation(remarkService.insertRemarkData, {
      onSuccess: (data) => {
          onData(data)
      },
  })
}

const useUploadRemarkFiles = (onData) => {
  return useMutation(remarkService.uploadRemarkFile, {
      onSuccess: (data) => {
          onData(data)
      },
  })
}

const remarkQueries = {
  useInsertRemarkData,
  useUploadRemarkFiles
};

export default remarkQueries;
